import React, { useEffect } from "react";
import { Pagination as MuiPagination } from "@mui/material";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onChange,
}) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "ArrowRight" && currentPage < totalPages) {
        onChange(currentPage + 1);
      }
      if (e.key === "ArrowLeft" && currentPage > 1) {
        onChange(currentPage - 1);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [currentPage, totalPages, onChange]);

  if (totalPages <= 1) return null;

  return (
    <MuiPagination
      page={currentPage}
      count={totalPages}
      onChange={(_, page) => onChange(page)}
      color="primary"
      sx={{ mt: 2 }}
    />
  );
};

export default Pagination;
